// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"Privacy_bodyWrapper__ukgWo"};